/**
 * SOLE cart order-note live save (cart-flow remediation #15).
 *
 * Document-delegated (survives section morphs) debounced save of the cart note to
 * POST /cart/update.js { note }. The <textarea name="note"> also lives inside the cart {% form %},
 * so with JS disabled the note still submits with the cart update / checkout. No section morph here
 * (the note text doesn't change any totals).
 */

const UPDATE_URL = () => window.Theme?.routes?.cart_update_url || '/cart/update.js';

/** @type {ReturnType<typeof setTimeout> | null} */
let timer = null;
/** @type {AbortController | null} */
let controller = null;

/** @param {string} note */
function save(note) {
  controller?.abort();
  controller = new AbortController();
  fetch(UPDATE_URL(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ note }),
    signal: controller.signal,
  }).catch(() => {});
}

document.addEventListener('input', (event) => {
  const el = event.target;
  if (!(el instanceof HTMLTextAreaElement) || !el.matches('[data-sole-cart-note]')) return;
  const value = el.value;
  if (timer) clearTimeout(timer);
  timer = setTimeout(() => save(value), 400);
});
